module.exports = __webpack_public_path__ + "static/media/OKTOCH.6994e6f8.svg";